import React, { useContext, useEffect, useState } from 'react';
import ContentCard from './ContentCard';
import {UserContext} from '../contexts/user-context';
import { Transition } from 'react-spring/renderprops';
import { withTranslation, Trans } from 'react-i18next';
import {Link} from "react-router-dom";
import UserService from '../services/user-service';

function UserEnableOTP({i18n}, props) {

  const userContext = useContext(UserContext)
  const [otpCode, setOtpCode] = useState(null)
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [allValues, setAllValues] = useState({
    otp_attempt: ''
  });
  const formClassName = userContext.errors != null ? '' : 'was-validated';
  const hasOtpErrors = (userContext.errors != null && userContext.errors.otpErrors != null);
  const otpInputClass = hasOtpErrors ? 'form-control is-invalid' : 'form-control';

  useEffect(() => {
    UserService.otpInfo().then(
        (info) => {
           setOtpCode(info.data.otp_code)
        }
    ).catch((e) => {
        console.log(e)
    })
  },[])

  const changeHandler = e => {
    let value = e.target.value;
    if(e.target.name == 'otp_attempt') {
      value = value ? value.substr(0, 6) : value
    }
    setAllValues({...allValues, [e.target.name]: value})
  }

  return (
        <ContentCard title={<Trans i18nKey="enable_otp" />} text={<Trans i18nKey="suggest_otp" />}>
            <form className={formClassName}
                onSubmit={(event)=> {
                event.preventDefault()
                event.stopPropagation()
                userContext.confirmOTP({user: {otp_attempt: allValues.otp_attempt}})
                }}>
                <div className="" style={{"text-align": "center"}}>
                    {loadingStatus &&
                        <div className="d-flex justify-content-center mt-3">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden"><Trans i18nKey="loading" />...</span>
                            </div>
                        </div>
                    }
                    <input type="hidden" name="authenticity_token" id="csrf-token" value={document.querySelector('[name=csrf-token]').content} />
                    <div className="form-floating my-3 qr-code" style={props} >
                        <img src='/users/otp_qr.svg'></img>
                        <div>{otpCode}</div>
                    </div>
                    <div className="form-floating my-3" style={props} >
                        <input
                            type="number"
                            name="otp_attempt"
                            value={allValues.otp_attempt}
                            onChange={changeHandler}
                            className={otpInputClass}
                            id="optInput"
                            placeholder="Otp" />
                        <label htmlFor="optInput"><Trans i18nKey="otp_input" /></label>
                        {hasOtpErrors &&
                            <div className="invalid-feedback">
                                {userContext.errors.otpErrors.map((error) => (
                                    <span key={error}><Trans i18nKey={error} /></span>
                                ))}
                            </div>
                        } 
                    </div>
                </div>
                <button className="btn btn-primary btn-lg mt-4 mb-3 px-5 w-100" type="submit">
                    <i className="obn obn-privacy-2 me-2"></i><Trans i18nKey="confirm_otp" />
                </button>
            </form>
        </ContentCard>
    );
}

export default withTranslation()(UserEnableOTP);
